var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.246 11.8247C23.246 12.1845 23.1031 12.5295 22.8487 12.7839C22.5943 13.0384 22.2492 13.1813 21.8894 13.1813H13.2975V21.7732C13.2975 22.133 13.1546 22.4781 12.9002 22.7325C12.6457 22.9869 12.3007 23.1298 11.9409 23.1298C11.5811 23.1298 11.236 22.9869 10.9816 22.7325C10.7272 22.4781 10.5843 22.133 10.5843 21.7732V13.1813H1.99236C1.63256 13.1813 1.2875 13.0384 1.03309 12.7839C0.778671 12.5295 0.635742 12.1845 0.635742 11.8247C0.635742 11.4649 0.778671 11.1198 1.03309 10.8654C1.2875 10.611 1.63256 10.4681 1.99236 10.4681H10.5843V1.87615C10.5843 1.51635 10.7272 1.17129 10.9816 0.916875C11.236 0.66246 11.5811 0.519531 11.9409 0.519531C12.3007 0.519531 12.6457 0.66246 12.9002 0.916875C13.1546 1.17129 13.2975 1.51635 13.2975 1.87615V10.4681H21.8894C22.2492 10.4681 22.5943 10.611 22.8487 10.8654C23.1031 11.1198 23.246 11.4649 23.246 11.8247Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.ef74de706ee148b2352a81908593eb74.svg";
export { ForwardRef as ReactComponent };